<div class="alerts-container">
    @for (alert of alerts(); track alert.id) {
        <div @slideInOut class="alert alert--{{ alert.type }}" role="alert" (click)="dismissAlert(alert.id)">
            <i class="{{ getIconClass(alert.type) }}"></i>
            <span class="alert__message">{{ alert.message }}</span>
            <button aria-label="Close" class="alert__close">
                <i class="fas fa-times"></i>
            </button>
        </div>
    }
</div>
